import { Box, Stack, Text } from 'braid-design-system';

import * as styles from './Testimonial.css';

interface Props {
  quote: string;
  name: string;
  company: string;
  role: string;
}

const Testimonial = ({ quote, name, company, role }: Props) => (
  <Box className={styles.root}>
    <Stack space="large">
      <Box className={styles.quote} display="flex" alignItems="center">
        <Box className={styles.italic}>
          <Text tone="secondary" size="large">
            {quote}
          </Text>
        </Box>
      </Box>
      <Stack space="medium">
        <Text size="large" weight="medium">
          {name}
        </Text>
        <Box className={styles.roleCompanyWrapper}>
          <Box className={styles.italic}>
            <Text tone="secondary">{company},&nbsp;</Text>
          </Box>
          <Box>
            <Text tone="secondary">{role}</Text>
          </Box>
        </Box>
      </Stack>
    </Stack>
  </Box>
);

export default Testimonial;
